import Image from "next/image";

const WhyChooseUsTwo = () => {
  return (
    <div className="why-us-area ptb-120 bg-f6ffeb">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-12 z-3">
            
            <div className="why-us-img position-relative">
              <Image
                width={405}
                height={297}
                sizes="100vw"
                src="/images/why-us/w1.jpg"
                alt="why-us-img"
              />
               <div className="box z-3  since d-lg-none">
                <h3 className="lh-1 text-uppercase ">SINCE 2002</h3>
                <p>
                  Our college is a place of knowledge and growth, shaping young minds through quality education and guidance. It has been a trusted center for learning and excellence for many years.
                </p>
              </div>
              <div className="box z-3 position-absolute since d-none d-lg-block">
                <h3 className="lh-1 text-uppercase ">SINCE 2002</h3>
                <p className="justify-clean ">
                  Our college is a place of knowledge and growth, shaping young minds through quality education and guidance. It has been a trusted center for learning and excellence for many years.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-12 z-1">
            <div className="why-us-text">
              <h2 className="text-uppercase fw-semibold fs-3">
                  Why Ashva Education Smart Classrooms, Strong Foundations
              </h2>
              <div className="features-list">
                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="box position-relative">
                      <div className="icon d-flex align-items-center justify-content-center">
                        <Image
                          width={28}
                          height={28}
                          src="/images/icons/expert2.svg"
                          alt="expert"
                        />
                      </div>
                      <h3 className="fw-medium">Expert Faculty</h3>
                      <p className="justify-clean ">Learn from experienced instructors who bring real-world expertise into the classroom.</p>

                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="box position-relative">
                      <div className="icon d-flex align-items-center justify-content-center">
                        <Image
                          width={28}
                          height={28}
                          src="/images/icons/small2.svg"
                          alt="small"
                        />
                      </div>
                      <h3 className="fw-medium">Small Class Sizes</h3>
                      <p>Enjoy personalized attention in small groups that encourage interaction and growth.</p>

                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="box position-relative">
                      <div className="icon d-flex align-items-center justify-content-center">
                        <Image
                          width={28}
                          height={28}
                          src="/images/icons/learning2.svg"
                          alt="learning"
                        />
                      </div>
                      <h3 className="fw-medium">Immersive Learning</h3>
                      <p>Experience practical, hands-on lessons designed to make learning engaging and effective.</p>

                    </div>
                  </div>
                </div>
              </div>
              <div className="image ">
                <Image
                  width={866}
                  height={413}
                  sizes="100vw"
                  src="/images/why-us/w2.jpg"
                  alt="why-us-img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUsTwo;
